import { TStep } from '../steps.types';

const step: TStep = {
  path: '',
  next: (trans) => {
    switch (trans.data.status) {
      case 'account-password':
        return 'account-password-page';

      case 'validation':
        return 'success-page';

      case 'done':
        return 'success-page';

      default:
        return trans.type === 'representative'
          ? 'representative-welcome-page'
          : 'spouse-welcome-page';
    }
  },
};

export default step;
